import { createSelector } from 'reselect';

// selectors
const getViews = (state) => state.views;
const getConfig = (state) => {
    const { config } = state;
    return config;
};

// reselect function
export const getAppState = createSelector(
    [getViews, getConfig],
    (views, config) => ({
        views,
        config
    })
);